import { useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { requestMagicLink } from "@/api/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthCard } from "@/components/common/AuthCard";

export const Route = createFileRoute("/login")({
  validateSearch: (s: Record<string, unknown>): { redirect?: string } => (typeof s.redirect === "string" ? { redirect: s.redirect } : {}),
  component: LoginPage,
});

function LoginPage() {
  const { redirect } = Route.useSearch();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await requestMagicLink(email.trim());
      navigate({ to: "/login/sent", search: { email: email.trim(), dev_link: res.dev_link, redirect } });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard title="Sign in to Tunic Tracker" subtitle="We will email you a sign-in link. No password.">
      <form onSubmit={submit} className="space-y-3">
        <Input
          type="email"
          autoFocus
          required
          placeholder="you@company.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        {error && <p className="text-sm text-danger">{error}</p>}
        <Button type="submit" className="w-full" disabled={busy || !email}>
          {busy ? "Sending..." : "Send sign-in link"}
        </Button>
      </form>
    </AuthCard>
  );
}
